<template>
	<div class="overlap-wrapper-subsection">

		<div class="overlap-6">
			<img class="mask-group" alt="Mask group" src="/img/mask-group-1.png" />
			<div style="width: 1200px;margin: 0 auto;position: relative;">
				<div class="group-8">
					<div class="text-wrapper-25">——最新动态</div>
					<div class="text-wrapper-26">
						以良好的职业道德、高度的责任感
						<br />
						为您提供最前沿的服务咨询
					</div>
				</div>

				<div style="width: 1200px;height: 800px;position: relative;margin: 0 auto;">
					<div v-for="(category, index) in newsSubCategories" :key="category.metadata.name"
						:class="['text-wrapper-' + (28 + index), { 'selected': selectedCategory && selectedCategory.metadata.name === category.metadata.name }]"
						:style="{ 
				        top: (220 + index * 50) + 'px',
				        left: '100px',
				        position: 'absolute',
				        cursor: 'pointer'
				      }" @click="selectCategory(category)" style="font-size: 20px !important;">
						{{ category.spec.displayName }}
					</div>
					<!-- 下划线，仅当已选中且是子栏目时才出现 -->
					<div class="rectangle-6" :style="{
    opacity: selectedCategory && newsSubCategories.some(c => c.metadata.name === selectedCategory.metadata.name) ? '1' : '0',
    top: (220 + newsSubCategories.findIndex(c => c.metadata.name === selectedCategory?.metadata.name) * 50 + 32) + 'px',
    transition: 'opacity 0.3s ease, top 0.3s ease'
  }" />

					<!-- 左侧「探索更多内容」 -->
					<div class="group-more-left" :style="{
     position: 'absolute',
     top: (220 + newsSubCategories.length * 50 + 20) + 'px',
     left: '100px'
  }">
						<div class="overlap-group-4" @mouseover="changeToHover" @mouseout="resetImage">
							<a :href="getMoreContentUrl()" class="more-content-link">
								<div class="text-wrapper-27">探索更多内容</div>
								<img class="vector-3" :src="imgSrc" alt="Vector" />
							</a>
						</div>
					</div>

					<div style="display: flex;flex-wrap: wrap;width: 960px;position: absolute;left: 276px;top: 200px;">
						<div v-for="(post, index) in currentPosts" :key="post.metadata.name" style="margin-right: 20px;margin-top: 20px;display: flex;flex-wrap: wrap;">
							<div class="overlap-7">
								<div class="text-wrapper-32" style="font-size: 16px !important;line-height:22px;">
									{{ formatDate(post.spec.publishTime).day }}.{{ formatDate(post.spec.publishTime).month }}
								</div>
								<div class="text-wrapper-33">
									<a :href="getArticleUrl(post)" target="_blank" class="article-link">
										{{truncateTitle(post.spec.title) }}
									</a>
							
								</div>
								<div class="text-wrapper-34">
									{{ formatExcerpt(post.status.excerpt) }}
								</div>
								<div class="text-wrapper-35" style="font-size: 10px !important;line-height:14px;">
									{{ formatDate(post.spec.publishTime).year }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 移除下方的探索更多内容按钮，只保留左侧的 -->
			</div>
		</div>

	</div>
</template>

<script>
	import {
		request
	} from '../../../api';

	export default {
		name: "NewsSection",
		data() {
			return {
				imgSrc: '/img/vector-2.svg', // 初始图片
				categories: [],
				currentPosts: [],
				selectedCategory: null,
				loading: false,
				error: ''
			}
		},
		computed: {
			// 只返回一级栏目（没有父级的栏目），显示所有栏目
			topLevelCategories() {
				return this.categories.filter(category =>
					!category.spec.parentName || category.spec.parentName === ''
				);
			},

			newsSubCategories() {
				const newsRoot = this.categories.find(c => c.metadata.name === 'category-sjvvlv0z');
				if (!newsRoot || !newsRoot.spec.children) return [];

				// 根据父级的 children name 过滤子栏目
				return this.categories.filter(c => newsRoot.spec.children.includes(c.metadata.name));
			},

			// 只返回有子栏目的父级栏目
			parentCategoriesWithChildren() {
				return this.topLevelCategories.filter(category =>
					this.getChildCategories(category.metadata.name).length > 0
				);
			}
		},
		async mounted() {
			// 页面加载时获取所有分类
			await this.loadCategories();
		},
		methods: {
			changeToHover() {
				this.imgSrc = '/img/Vector1s.png' // 鼠标移入时的图片
			},
			resetImage() {
				this.imgSrc = '/img/vector-2.svg' // 鼠标移出还原图片
			},
			truncateTitle(text) {
				return text.length > 30 ? text.slice(0, 30) + '...' : text
			},
			async loadCategories() {
				this.loading = true;
				this.error = '';

				try {
					// 从栏目API直接获取所有栏目（包括没有文章的栏目）
					try {
						const categoriesData = await request('api.content.halo.run/v1alpha1/categories');
						console.log('从栏目API获取到的栏目数据:', categoriesData);

						if (categoriesData.items && categoriesData.items.length > 0) {
							this.categories = categoriesData.items.map(category => ({
								...category,
								status: {
									postCount: 0
								} // 初始化文章计数
							}));

							// 获取文章数据来更新文章计数
							const postsData = await request('api.content.halo.run/v1alpha1/posts');

							// 更新每个栏目的文章计数
							if (postsData.items && postsData.items.length > 0) {
								postsData.items.forEach(post => {
									if (post.categories && post.categories.length > 0) {
										post.categories.forEach(category => {
											const existingCategory = this.categories.find(c => c
												.metadata.name === category.metadata.name);
											if (existingCategory) {
												existingCategory.status.postCount++;
											}
										});
									}
								});
							}
						}
					} catch (error) {
						console.warn('从栏目API获取失败，回退到从文章提取:', error);

						// 回退到从文章数据中提取分类信息
						const postsData = await request('api.content.halo.run/v1alpha1/posts');

						// 从文章数据中提取所有分类
						const categoryMap = new Map();

						if (postsData.items && postsData.items.length > 0) {
							postsData.items.forEach(post => {
								if (post.categories && post.categories.length > 0) {
									post.categories.forEach(category => {
										if (!categoryMap.has(category.metadata.name)) {
											categoryMap.set(category.metadata.name, {
												metadata: {
													name: category.metadata.name
												},
												spec: {
													displayName: category.spec.displayName,
													parentName: category.spec.parentName ||
														null
												},
												status: {
													postCount: 1
												}
										});
										} else {
											// 增加文章计数
											categoryMap.get(category.metadata.name).status.postCount++;
										}
									});
								}
							});
						}

						// 转换为数组
						this.categories = Array.from(categoryMap.values());
					}

					// 默认选择第一个分类
					// 默认选中"行业公告"
					const defaultSub = this.newsSubCategories.find(c => c.metadata.name === 'category-wllimp6m');
					if (defaultSub) {
						this.selectCategory(defaultSub);
					} else if (this.newsSubCategories.length) {
						// 兜底：选第一个子栏目
						this.selectCategory(this.newsSubCategories[0]);
					}
				} catch (error) {
					this.error = `获取分类失败: ${error.message}`;
				} finally {
					this.loading = false;
				}
			},

			// 获取指定父级栏目的子栏目
			getChildCategories(parentName) {
				return this.categories.filter(category =>
					category.spec.parentName === parentName
				);
			},

			selectCategory(category) {
				this.selectedCategory = category;
				console.log('选中栏目:', category.spec.displayName);
				console.log('栏目样式类:', 'text-wrapper-' + (28 + this.topLevelCategories.findIndex(c => c.metadata.name ===
					category.metadata.name)));
				console.log('是否显示默认下划线:', category.metadata.name === this.topLevelCategories[0]?.metadata.name);

				// 如果是父级栏目，获取所有子栏目的文章
				if (this.isParentCategory(category.metadata.name)) {
					this.loadParentCategoryArticles(category);
				} else {
					// 如果是子栏目，只获取该子栏目的文章
					this.loadArticles(category.metadata.name);
				}
			},

			// 判断是否为父级栏目
			isParentCategory(categoryId) {
				return this.getChildCategories(categoryId).length > 0;
			},

			async loadArticles(categoryId) {
				this.loading = true;
				this.error = '';

				try {
					// 使用正确的API格式：categories/{name}/posts
					const data = await request(`api.content.halo.run/v1alpha1/categories/${categoryId}/posts`);
					const allArticles = data.items || [];
					console.log('获取到文章数量:', allArticles.length);

				// 	this.currentPosts = allArticles.filter(article =>
				// 		article &&
				// 		article.spec &&
				// 		article.spec.title
				// 	);
					
					this.currentPosts = allArticles
            .filter(article => article && article.spec && article.spec.title)
            .slice(0, 4); // 限制最多显示四条
					
					

					console.log('过滤后的文章数量:', this.currentPosts.length);
					console.log('文章标题:', this.currentPosts.map(a => a.spec.title));
				} catch (error) {
					this.error = `获取文章失败: ${error.message}`;
					this.currentPosts = [];
				} finally {
					this.loading = false;
				}
			},

			// 加载父级栏目下所有子栏目的文章
			async loadParentCategoryArticles(parentCategory) {
				this.loading = true;
				this.error = '';

				try {
					const childCategories = this.getChildCategories(parentCategory.metadata.name);
					let allArticles = [];

					// 获取父级栏目自己的文章
					try {
						const parentData = await request(
							`api.content.halo.run/v1alpha1/categories/${parentCategory.metadata.name}/posts`);
						const parentArticles = (parentData.items || []).filter(article =>
							article && article.spec && article.spec.title
						);
						allArticles = [...parentArticles];
					} catch (error) {
						console.warn('获取父级栏目文章失败:', error);
					}

					// 获取所有子栏目的文章
					for (const childCategory of childCategories) {
						try {
							const childData = await request(
								`api.content.halo.run/v1alpha1/categories/${childCategory.metadata.name}/posts`);
							const childArticles = (childData.items || []).filter(article =>
								article && article.spec && article.spec.title
							);
							allArticles = [...allArticles, ...childArticles];
						} catch (error) {
							console.warn(`获取子栏目 ${childCategory.spec.displayName} 文章失败:`, error);
						}
					}

				// 	// 按发布时间排序
				// 	this.currentPosts = allArticles.sort((a, b) =>
				// 		new Date(b.spec.publishTime) - new Date(a.spec.publishTime)
				// 	);
					
					// 按发布时间排序并限制最多显示四条
        this.currentPosts = allArticles
            .sort((a, b) => new Date(b.spec.publishTime) - new Date(a.spec.publishTime))
            .slice(0, 4);


				} catch (error) {
					this.error = `获取父级栏目文章失败: ${error.message}`;
					this.currentPosts = [];
				} finally {
					this.loading = false;
				}
			},

			formatDate(dateString) {
				const date = new Date(dateString)
				// 使用UTC方法避免时区转换问题
				const year = date.getUTCFullYear()
				const month = String(date.getUTCMonth() + 1).padStart(2, '0')
				const day = String(date.getUTCDate()).padStart(2, '0')

				return {
					year: year,
					month: month,
					day: day
				}
			},

			// 处理摘要文本，限制为两行
			formatExcerpt(excerpt) {
				if (!excerpt) return '';
				return excerpt;
			},

			// 构建文章详情链接
			getArticleUrl(article) {
				if (!article || !article.metadata || !article.metadata.name) {
					return '#';
				}

				// 使用文章的name参数构建内部路由链接
				const articleName = article.metadata.name;

				// 使用Vue Router的方式构建链接
				// 由于使用的是hash模式，直接构建hash路由链接
				const url = `#/newsdetail?name=${articleName}`;
				console.log('生成的文章详情链接:', url);
				return url;
			},

			// 构建"探索更多内容"链接
			getMoreContentUrl() {
				// 跳转到新闻资讯页面
				return '#/NewsUpdatesPage';
			}
		}
	};
</script>

<style>
	.overlap-wrapper-subsection {
		height: 800px;
		width: 100%;
		min-width: 1200px; /* 确保最小宽度 */
	}

	.overlap-wrapper-subsection .overlap-6 {
		background-color: #fafafa;
		height: 800px;
		width: 100%;
		min-width: 1200px;
	}

	.overlap-wrapper-subsection .mask-group {
		height: 800px;
		left: 0;
		position: absolute;
		top: 0;
		width: 100%;
	}

	.overlap-wrapper-subsection .group-8 {
		height: 101px;
		left: 100px;
		position: absolute;
		top: 89px;
		width: 424px;
	}

	.overlap-wrapper-subsection .text-wrapper-25 {
		color: var(--yxd-41k);
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 12px;
		font-weight: 500;
		left: 0;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 0;
	}

	.overlap-wrapper-subsection .text-wrapper-26 {
		color: var(--x-1);
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 28px;
		font-weight: 400;
		left: 0;
		letter-spacing: 0;
		line-height: 36px;
		position: absolute;
		top: 29px;
	}

	.overlap-wrapper-subsection .group-9 {
		display: none; /* 隐藏下方的探索更多内容按钮 */
	}

	.overlap-wrapper-subsection .overlap-group-4 {
		background-color: #ffffff;
		border: 1px solid;
		border-color: #e4e4e4;
		border-radius: 21px;
		height: 42px;
		position: relative;
		width: 144px;
		cursor: pointer;
		transition: all 0.3s ease;
	}

	.overlap-wrapper-subsection .overlap-group-4:hover {
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		font-weight: bold;
		color: #fff !important;
		background-color: #7a3529;
	}

	.overlap-wrapper-subsection .text-wrapper-27 {
		font-family: "PingFang SC-Regular", Helvetica;
		font-size: 12px;
		font-weight: 400;
		left: 25px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 11px;
	}

	.overlap-wrapper-subsection .vector-3 {
		height: 7px;
		left: 104px;
		object-fit: cover;
		position: absolute;
		top: 16px;
		width: 13px;
	}

	.overlap-wrapper-subsection .text-wrapper-28 {
		color: var(--yxd-41k);
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 20px;
		font-weight: 500;
		left: 100px;
		letter-spacing: 0;
		line-height: 28px;
		position: absolute;
		top: 220px;
	}

	.overlap-wrapper-subsection .text-wrapper-29 {
		color: var(--x-1);
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 20px;
		font-weight: 500;
		left: 100px;
		letter-spacing: 0;
		line-height: 28px;
		position: absolute;
		top: 270px;
	}

	.overlap-wrapper-subsection .text-wrapper-30 {
		color: var(--x-1);
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 20px;
		font-weight: 500;
		left: 100px;
		letter-spacing: 0;
		line-height: 28px;
		position: absolute;
		top: 320px;
	}

	.overlap-wrapper-subsection .text-wrapper-31 {
		color: var(--x-1);
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 20px;
		font-weight: 500;
		left: 100px;
		letter-spacing: 0;
		line-height: 28px;
		position: absolute;
		top: 370px;
	}

	.overlap-wrapper-subsection .rectangle-6 {
		background-color: var(--yxd-41k);
		height: 4px;
		left: 100px;
		position: absolute;
		top: 252px;
		width: 78px;
	}

	.overlap-wrapper-subsection .group-10 {
		height: 172px;
		left: 400px;
		position: absolute;
		top: 235px;
		width: 448px;
	}

	.overlap-wrapper-subsection .overlap-7 {
		background-color: #ffffff;
		height: 172px;
		position: relative;
		width: 440px;
	}

	.overlap-wrapper-subsection .text-wrapper-32 {
		color: var(--x-1);
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 16px;
		font-weight: 400;
		left: 32px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 32px;
	}

	.overlap-wrapper-subsection .text-wrapper-33 {
		color: var(--x-1);
		font-family: "PingFang SC-Regular", Helvetica;
		font-size: 16px;
		font-weight: 400;
		left: 92px;
		letter-spacing: 0;
		line-height: 24px;
		position: absolute;
		top: 32px;
		width: 320px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
		word-break: break-word;
		line-height: 24px;
	}

	.overlap-wrapper-subsection .text-wrapper-34 {
		color: var(--x-2);
		font-family: "PingFang SC-Regular", Helvetica;
		font-size: 14px;
		font-weight: 400;
		left: 92px;
		letter-spacing: 0;
		line-height: 22px;
		position: absolute;
		top: 96px;
		width: 322px;
		word-wrap: break-word;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
	}

	.overlap-wrapper-subsection .text-wrapper-35 {
		color: var(--x-3);
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 10px;
		font-weight: 400;
		left: 32px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 58px;
	}

	.overlap-wrapper-subsection .group-11 {
		height: 172px;
		left: 400px;
		position: absolute;
		top: 423px;
		width: 448px;
	}

	.overlap-wrapper-subsection .group-12 {
		height: 172px;
		left: 850px;
		position: absolute;
		top: 235px;
		width: 448px;
	}

	.overlap-wrapper-subsection .group-13 {
		height: 172px;
		left: 850px;
		position: absolute;
		top: 423px;
		width: 448px;
	}

	/* 动态文章列表样式 - 保持与原有样式一致 */
	.overlap-wrapper-subsection .group-10,
	.overlap-wrapper-subsection .group-11,
	.overlap-wrapper-subsection .group-12,
	.overlap-wrapper-subsection .group-13,
	.overlap-wrapper-subsection .group-14,
	.overlap-wrapper-subsection .group-15,
	.overlap-wrapper-subsection .group-16,
	.overlap-wrapper-subsection .group-17 {
		height: 172px;
		position: absolute;
		width: 448px;
	}

	.overlap-wrapper-subsection .text-wrapper-32 {
		color: var(--x-1);
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 16px;
		font-weight: 400;
		left: 32px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 32px;
	}

	.overlap-wrapper-subsection .text-wrapper-33 {
		color: var(--x-1);
		font-family: "PingFang SC-Regular", Helvetica;
		font-size: 16px;
		font-weight: 400;
		left: 92px;
		letter-spacing: 0;
		line-height: 24px;
		position: absolute;
		top: 32px;
		width: 320px;
	}

	.overlap-wrapper-subsection .text-wrapper-34 {
		color: var(--x-2);
		font-family: "PingFang SC-Regular", Helvetica;
		font-size: 14px;
		font-weight: 400;
		left: 92px;
		letter-spacing: 0;
		line-height: 22px;
		position: absolute;
		top: 96px;
		width: 322px;
	}

	.overlap-wrapper-subsection .text-wrapper-35 {
		color: var(--x-3);
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 10px;
		font-weight: 400;
		left: 32px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 58px;
	}

	/* 第一个栏目的选中状态 - 只改变颜色，不添加下划线 */
	.overlap-wrapper-subsection .text-wrapper-28.selected {
		color: #8B4513 !important;
		transition: all 0.3s ease;
		font-weight: 600 !important;
		text-shadow: 0 0 1px rgba(139, 69, 19, 0.3);
		display: inline-block;
		width: fit-content;
	}

	/* 选中状态的样式 - 排除第一个栏目，避免双下划线 */
	.overlap-wrapper-subsection .text-wrapper-29.selected,
	.overlap-wrapper-subsection .text-wrapper-30.selected,
	.overlap-wrapper-subsection .text-wrapper-31.selected,
	.overlap-wrapper-subsection .text-wrapper-32.selected,
	.overlap-wrapper-subsection .text-wrapper-33.selected,
	.overlap-wrapper-subsection .text-wrapper-34.selected,
	.overlap-wrapper-subsection .text-wrapper-35.selected,
	.overlap-wrapper-subsection .text-wrapper-36.selected,
	.overlap-wrapper-subsection .text-wrapper-37.selected,
	.overlap-wrapper-subsection .text-wrapper-38.selected,
	.overlap-wrapper-subsection .text-wrapper-39.selected {
		color: #8B4513 !important;
		transition: all 0.3s ease;
		font-weight: 600 !important;
		text-shadow: 0 0 1px rgba(139, 69, 19, 0.3);
		display: inline-block;
		width: fit-content;
	}

	/* 文章标题链接样式 - 使用更高优先级 */
	.overlap-wrapper-subsection .text-wrapper-33 .article-link {
		text-decoration: none !important;
		color: inherit !important;
		cursor: pointer !important;
		transition: all 0.3s ease !important;
		font-size: 16px;
		width: 100% !important;
		line-height: 24px !important;
	}

	/* 探索更多内容链接样式 */
	.overlap-wrapper-subsection .more-content-link {
		text-decoration: none !important;
		color: inherit !important;
		display: block !important;
		width: 100% !important;
		height: 100% !important;
		transition: all 0.3s ease !important;
	}

	/* 确保在移动设备上也能正常显示 */
	@media screen and (max-width: 1200px) {
		.overlap-wrapper-subsection {
			min-width: 1200px;
			overflow-x: auto;
		}
	}
</style>